/** Autentia */
export const OUTOUT_AUTENTIA_FIELDS = [
  'Erc',
  'NroAudit',
  'ErcDesc',
  'oNombres',
  'oSexo',
  'oFchNac'
];
export const VERIFY_AUTENTIA_URL = '../FALP/verificadatos';
export const AUTENTIA_FOCUS = true;

/** keys */
export const MAINTAINER_KEY = 'MT_K';
export const DOUBLE_SPACE_KEY_CODE = 229;
export const DOT_CHARACTER = '.';
export const ONE_SECOND = 1000;

export const NAVBAR_WIDTH = 250;
export const DATE_FRONT_FORMAT = 'DD-MM-YYYY';
export const DATE_SERVER_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FRONT_FORMAT = 'DD-MM-YYYY HH:mm';
export const DATE_AFTER_SHOW = 'Complete fecha Desde';

/** table */
export const ROWS_PER_PAGE_DEFAULT = 10;
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const ORDER_BY_DEFAULT = 'asc';
export const INITIAL_PAGE_DEFAULT = 0;
/** */

/** CONSTANTS */

export const TIME_AFTER_MESSAGE = 2000;
export const MAXIMUM_SELECTION_SERVICE = 6;
export const MINIMUM_SELECTION_SERVICE = 1;

export const MAXIMUM_DNI_LENGTH = 9;
export const MINIMUM_DNI_LENGTH = 6;
export const MINIMUM_TELEPHONE_LENGTH = 9;

export const MAXIMUM_CEDULA_LENGTH = 10;
export const MINIMUM_CEDULA_LENGTH = 9;

export const LIMIT_SHOW_CEDULA = 50000000;
export const INSURANCE_WITH_PLAN = 'COLMENA';
export const ADDRESS_NORMALIZE_PREFIX = 'normalizeAddress';
export const MAXIMUM_AMOUNT_DIGITS = 12;

export const MAXIMUM_ADDRESS_LENGTH = 80;
export const MAXIMUM_ADDRESS_NUMBER_LENGTH = 12;
export const MAXIMUM_EMAIL_LENGTH = 60;
/** END */

export const WARRANTY_MAX_LENGTH_CODE = 3;
export const WARRANTY_MAX_LENGTH_NAME = 50;

export const SERVICE_MAX_LENGTH_CODE = 12;
export const SERVICE_MAX_LENGTH_NAME = 120;

export const REGION_MAX_LENGTH_CODE = 3;
export const REGION_MAX_LENGTH_NAME = 50;
export const REGION_MAX_LENGTH_ORDER = 12;

export const COMMUNE_MAX_LENGTH_CODE = 5;
export const COMMUNE_MAX_LENGTH_NAME = 20;
export const COMMUNE_EFX_MAX_LENGTH_NAME = 20;
export const COMMUNE_LENGTH_PROVINCE = 50;

export const HEALTH_PLAN_MAX_LENGTH_RANGE = 3;
export const HEALTH_PLAN_LENGTH_COVERAGE = 3;

export const RISK_MAX_LENGTH_ORDER = 12;
export const RISK_NAME_MAX_LENGTH = 50;
export const RISK_NUMBER_MAX_LENGTH = 1;

export const INSURANCE_NAME_MAX_LENGTH = 50;
export const INSURANCE_CODE_MAX_LENGTH = 3;

export const USER_MIN_LENGTH_NAME = 3;
export const USER_MAX_LENGTH_NAME = 30;
export const USER_MIN_LENGTH_LASTNAME = 3;
export const USER_MAX_LENGTH_LASTNAME = 30;
export const USER_MIN_LENGTH_PASSWORD = 8;
export const USER_MAX_LENGTH_PASSWORD = 20;

export const USER_MIN_LENGTH_EMAIL = 0;
export const USER_MAX_LENGTH_EMAIL = 200;
export const MAX_LOGIN_ATTEMPTS = 3;

export const decisionTrans = value => {
  const definition = {
    Paciente_convenio: {
      name: 'Paciente Convenio',
      state: 'successful'
    },
    Aprobar: {
      name: 'Aprobar',
      state: 'successful'
    },
    Aprobación: {
      name: 'Aprobación',
      state: 'successful'
    }
  };

  if (value && value.toLowerCase() === 'paciente convenio') {
    return definition.Paciente_convenio;
  }
  if (!value || !definition[value]) {
    return {
      name: value,
      state: 'pedient'
    };
  }

  return definition[value];
};

export const stateTrans = value => {
  const definition = {
    completed: {
      name: 'Completado',
      state: 'successful'
    }
  };
  if (!value) {
    return {
      name: value,
      state: 'pedient'
    };
  }
  return definition[value];
};

export const ROLE_LIST = [
  {
    code: 'Administrador',
    name: 'Administrador'
  },
  {
    code: 'Usuario',
    name: 'Usuario'
  }
];

export const AUTENTIA_ERROR_CODES = [204, 9702,9201,-3];

export const FINGER_DISABLED_STATUS_CODE = 5;
export const FINGER_NORMAL_STATUS_CODE = 4;
export const FINGER_RUNNING_STATUS_CODE = 3;
export const FINGER_ERROR_STATUS_CODE = 2;
export const FINGER_WARNING_STATUS_CODE = 1;
export const FINGER_SUCCESSFULL_STATUS_CODE = 0;

export const RISK_INDICATORS = [{ value: 0, name: 0 }, { value: 1, name: 1 }];
